/**
 * billing.service.ts — Layer 3: Billing & Payments Domain
 */

import { getRequest, postRequest, patchRequest } from './http.service';
import {
  URL_BILLING_SUBSCRIPTION,
  URL_BILLING_PER_SEAT_INFO,
  URL_BILLING_PRORATION_PREVIEW,
  URL_BILLING_CREATE_PORTAL,
  URL_BILLING_CHECKOUT_SEAT,
  URL_BILLING_CHECKOUT,
  URL_BILLING_INTERVAL,
  URL_CREATE_CHECKOUT,
  URL_CREATE_PAYMENT_INTENT,
  URL_SAVE_PAYMENT_DETAILS,
} from './url.service';

/** Get the current subscription/billing status for an org */
export const fetchBillingSubscription = (orgId: string) =>
  getRequest(URL_BILLING_SUBSCRIPTION(orgId));

/** Get per-seat pricing info for an org */
export const fetchPerSeatInfo = (orgId: string) =>
  getRequest(URL_BILLING_PER_SEAT_INFO(orgId));

/** Preview the proration charge/credit for switching billing interval/plan */
export const fetchProrationPreview = (orgId: string, newPriceId: string) =>
  getRequest(URL_BILLING_PRORATION_PREVIEW(orgId, newPriceId));

/** Create a Stripe billing-portal session (manage subscription) */
export const createBillingPortalSession = (orgId: string) =>
  postRequest(URL_BILLING_CREATE_PORTAL, { orgId });

/** Start a per-seat Stripe checkout session */
export const createPerSeatCheckoutSession = (payload: Record<string, unknown>) =>
  postRequest(URL_BILLING_CHECKOUT_SEAT, payload);

/** Start a standard Stripe checkout session */
export const createCheckoutSession = (payload: Record<string, unknown>) =>
  postRequest(URL_BILLING_CHECKOUT, payload);

/** Switch the org's billing interval/plan */
export const updateBillingInterval = (orgId: string, newPriceId: string) =>
  patchRequest(URL_BILLING_INTERVAL, { orgId, newPriceId });

/** Create a one-off Stripe checkout session (non-subscription payment) */
export const createOneOffCheckoutSession = (payload: Record<string, unknown>) =>
  postRequest(URL_CREATE_CHECKOUT, payload);

/** Create a Stripe PaymentIntent */
export const createPaymentIntent = (payload: Record<string, unknown>) =>
  postRequest(URL_CREATE_PAYMENT_INTENT, payload);

/** Save payment details after a successful checkout */
export const savePaymentDetails = (payload: Record<string, unknown>) =>
  postRequest(URL_SAVE_PAYMENT_DETAILS, payload);
